export default "__VITE_ASSET__CS7H_8p___"